
import SBEditable from "../../../components/sbEditable/sbEditable"
import StoryblokImageBasic from "../../../components/storyblokImageBasic/storyblokImageBasic"

import { useStoryblokSeries } from "../../../hooks/useStoryblokSeries"

import { LeftArrowSVG, RightArrowSVG } from "../../../svg"
import styles from "./seriesSliderPanel.module.scss"
import { useCompressedImage } from "../../../components/storyblokImageBasic/helpers"

/// Blok:seriessliderpanel
// headline:string
// subtitle:string
// aside_image:SBImage
// series_list:[uuid]
function SeriesSliderPanel({ blok, story_language }) {
  const series = useStoryblokSeries(story_language)

  let seriesData = []
  if(series) {
    blok.series_list.forEach((seriesUuid)=>{
      const data = series.find((d)=>{return d.uuid === seriesUuid})
      if(data) { seriesData.push(data) }
    })
  }

  if (!seriesData.length) {
    return null;
  }

  return (
    <div className={styles.background}>
      <SBEditable blok={blok}>
        <div className={styles.wrapper}>
          <div className={styles.contentWrapper}>
            {blok.headline ? <h2 className={styles.headline}>{blok.headline}<img src={useCompressedImage('https://a.storyblok.com/f/178900/64x45/15dd94e445/hearts.png')} /></h2> : null}
            {blok.subtitle ? <p className={styles.subtitle}>{blok.subtitle}</p> : null}
            <div className={styles.slider}>
              <div className={styles.sliderControls}>
                <div className={styles.sliderBtn}>
                  <LeftArrowSVG />
                </div>
                <div className={styles.sliderContent}>
                  <div className={styles.sliderTrack}>
                    {seriesData.map((s)=>(
                      <div key={s.uuid} className={styles.sliderItem}>
                        <StoryblokImageBasic image={s.image_portrait} />
                        {s.title}
                      </div>
                    ))}
                  </div>
                </div>
                <div className={styles.sliderBtn}>
                  <RightArrowSVG />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.asideImage}>
            {blok.aside_image ? <StoryblokImageBasic image={blok.aside_image} /> : null}
          </div>
        </div>
      </SBEditable>
    </div>
  )
}

export default SeriesSliderPanel
